import { http } from 'services'

const state = () => ({
  all: {data: []},
  active: {},
  errors: null
})

const getters = {}

const actions = {
  ['integrationSystems.getAll'] ({ commit }, params = {}) {
    commit('CLEAR_INTEGRATION_SYSTEM_ERRORS')

    return http.get('integration-systems', {params})
      .then(res => commit('GET_ALL_INTEGRATION_SYSTEMS', res))
      .catch(err => commit('INTEGRATION_SYSTEMS_ERROR', err))
  },

  ['integrationSystems.get'] ({ commit }, id) {
    commit('CLEAR_INTEGRATION_SYSTEM_ERRORS')

    return http.get('integration-systems/' + id)
      .then(res => commit('GET_INTEGRATION_SYSTEM', res))
      .catch(err => commit('INTEGRATION_SYSTEMS_ERROR', err))
  },

  ['integrationSystems.create'] ({ commit }, data) {
    commit('CLEAR_INTEGRATION_SYSTEM_ERRORS')

    return http.post('integration-systems', data)
      .catch(err => commit('INTEGRATION_SYSTEMS_ERROR', err))
  },

  ['integrationSystems.update'] ({ commit }, {id, data}) {
    commit('CLEAR_INTEGRATION_SYSTEM_ERRORS')

    return http.put('integration-systems/' + id, data)
      .then(res => commit('GET_INTEGRATION_SYSTEM', res))
      .catch(err => commit('INTEGRATION_SYSTEMS_ERROR', err))
  },

  ['integrationSystems.remove'] ({ commit }, id) {
    commit('CLEAR_INTEGRATION_SYSTEM_ERRORS')

    return http.delete('integration-systems/' + id)
      .then(() => commit('REMOVE_INTEGRATION_SYSTEM', id))
      .catch(err => commit('INTEGRATION_SYSTEMS_ERROR', err))
  }
}

const mutations = {
  GET_ALL_INTEGRATION_SYSTEMS (state, res) {
    state.all = res.data
  },

  GET_INTEGRATION_SYSTEM (state, res) {
    state.active = res.data
  },

  REMOVE_INTEGRATION_SYSTEM (state, id) {
    const items = Array.isArray(state.all) ? state.all : state.all.data
    if (items) {
      const filtered = _.filter(items, item => item.id != id)
      if (Array.isArray(state.all)) {
        state.all = filtered
      } else {
        state.all.data = filtered
      }
    }
  },

  INTEGRATION_SYSTEMS_ERROR (state, err) {
    try {
      state.errors = err.response.data
    } catch (e) {
      state.errors = err
    }
  },

  CLEAR_INTEGRATION_SYSTEM_ERRORS (state) {
    state.errors = null
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
